import React from 'react';

export const SendArrow: React.FC = () => (
  <svg width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8 4C8 4.55228 7.55228 5 7 5H1C0.447715 5 0 5.44772 0 6V8C0 8.55229 0.447715 9 1 9H7C7.55228 9 8 9.44772 8 10V12.5858C8 13.4767 9.07714 13.9229 9.70711 13.2929L15.2929 7.70711C15.6834 7.31658 15.6834 6.68342 15.2929 6.29289L9.70711 0.707105C9.07714 0.0771403 8 0.523309 8 1.41421V4Z' />
  </svg>
);
